// Recovered compiled webpack factory 74841. Edit this function expression; run npm run build.
(e, t, n) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var n in t) Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    })(t, {
      default: function () {
        return y;
      },
      defaultHead: function () {
        return c;
      },
    }));
  let r = n(28140),
    o = n(49417),
    l = n(95155),
    d = o._(n(12115)),
    i = r._(n(1262)),
    s = n(90737),
    a = n(82073),
    u = n(60861);
  function c(e) {
    void 0 === e && (e = !1);
    let t = [(0, l.jsx)("meta", { charSet: "utf-8" }, "charset")];
    return (
      e ||
        t.push((0, l.jsx)("meta", { name: "viewport", content: "width=device-width" }, "viewport")),
      t
    );
  }
  function f(e, t) {
    return "string" == typeof t || "number" == typeof t
      ? e
      : t.type === d.default.Fragment
        ? e.concat(
            d.default.Children.toArray(t.props.children).reduce(
              (e, t) => ("string" == typeof t || "number" == typeof t ? e : e.concat(t)),
              [],
            ),
          )
        : e.concat(t);
  }
  n(94781);
  let p = ["name", "httpEquiv", "charSet", "itemProp"];
  function h(e, t) {
    let { inAmpMode: n } = t;
    return e
      .reduce(f, [])
      .reverse()
      .concat(c(n).reverse())
      .filter(
        (function () {
          let e = new Set(),
            t = new Set(),
            n = new Set(),
            r = {};
          return (o) => {
            let l = !0,
              d = !1;
            if (o.key && "number" != typeof o.key && o.key.indexOf("$") > 0) {
              d = !0;
              let t = o.key.slice(o.key.indexOf("$") + 1);
              e.has(t) ? (l = !1) : e.add(t);
            }
            switch (o.type) {
              case "title":
              case "base":
                t.has(o.type) ? (l = !1) : t.add(o.type);
                break;
              case "meta":
                for (let e = 0, t = p.length; e < t; e++) {
                  let t = p[e];
                  if (o.props.hasOwnProperty(t))
                    if ("charSet" === t) n.has(t) ? (l = !1) : n.add(t);
                    else {
                      let e = o.props[t],
                        n = r[t] || new Set();
                      ("name" !== t || !d) && n.has(e) ? (l = !1) : (n.add(e), (r[t] = n));
                    }
                }
            }
            return l;
          };
        })(),
      )
      .reverse()
      .map((e, t) => {
        let n = e.key || t;
        return d.default.cloneElement(e, { key: n });
      });
  }
  let y = function (e) {
    let { children: t } = e,
      n = (0, d.useContext)(s.AmpStateContext),
      r = (0, d.useContext)(a.HeadManagerContext);
    return (0, l.jsx)(i.default, {
      reduceComponentsToState: h,
      headManager: r,
      inAmpMode: (0, u.isInAmpMode)(n),
      children: t,
    });
  };
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
